/**
 * Represents a limit of one year in days
 */
export const MAX_CLOSED_POPUP_DAYS = 365
